import { css } from '@emotion/react';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';
import { ellipsis } from '_assets/css/global';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const profileDropdownContainerStyles = css`
  color: var(${DesignToken.ContentBasicPrimary});

  ${MEDIA_MIN_SM} {
    margin-left: var(${SpacingToken.Spacing1});
  }
`;

export const popoverStyles = css`
  width: auto;
  min-height: fit-content;
  border-radius: var(${RadiusToken.Radius4});
  margin: var(${SpacingToken.Spacing2}) var(${SpacingToken.Spacing8}) 0 0;
  min-width: fit-content;
  max-width: 316px;
  z-index: 2347483639;

  ${MEDIA_MIN_SM} {
    max-width: 560px;
  }
`;

export const dropdownContainerStyles = css`
  padding: var(${SpacingToken.Spacing6});
  border-radius: var(${RadiusToken.Radius4});
  min-width: 296px;

  ${MEDIA_MIN_SM} {
    max-width: 560px;
  }
`;

export const userDetailsContainerStyles = css`
  display: flex;
  align-items: center;
  margin-bottom: var(${SpacingToken.Spacing4});
  margin-left: var(${SpacingToken.Spacing3});
  max-width: 100%;
  ${MEDIA_MIN_SM} {
    max-width: 560px;
  }
`;

export const userDetailsRightContainerStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: var(${SpacingToken.Spacing4});
  max-width: 100%;
  ${MEDIA_MIN_SM} {
    max-width: 560px;
  }
`;

export const accountEmailStyles = css`
  ${ellipsis}
  font-size: 14px;
  line-height: 20px;
  font-weight: normal;
  color: var(${DesignToken.ContentBasicSecondary});
  max-width: 63vw;

  ${MEDIA_MIN_SM} {
    max-width: 436px;
  }
`;

export const accountNameStyles = css`
  ${ellipsis}
  margin: 0;
  max-width: 63vw;
  ${MEDIA_MIN_SM} {
    max-width: 436px;
  }
`;

export const popoverLineStyles = css`
  width: 100%;
  height: 2px;
  background-color: var(${DesignToken.BorderBasicSecondary});
  margin: var(${SpacingToken.Spacing2}) 0;
`;

export const linkStyles = css`
  color: var(${DesignToken.ContentBasicPrimary});
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  &:focus-visible {
    outline: none;
  }
`;

export const bottomLinkContainerStyles = css`
  display: flex;
  align-items: center;
  padding: var(${SpacingToken.Spacing2}) var(${SpacingToken.Spacing4});
  border-radius: var(${RadiusToken.Radius3});
  margin-bottom: var(${SpacingToken.Spacing1});

  &:hover {
    background-color: var(${DesignToken.SurfaceSecondaryDefault});
    cursor: pointer;
  }
`;

export const organizationNameContainerStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0 0 var(${SpacingToken.Spacing4}) var(${SpacingToken.Spacing4});

  ${MEDIA_MIN_SM} {
    max-width: 436px;
  }
`;

export const yourOrganizationStyles = css`
  color: var(${DesignToken.ContentBasicSecondary});
  display: flex;
  justify-content: flex-start;
  text-align: left;
`;

export const organizationNameStyles = css`
  ${ellipsis}
  display: flex;
  justify-content: flex-start;
  margin: 0;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  max-width: 200px;
  ${MEDIA_MIN_SM} {
    max-width: 436px;
  }
`;
